import React from "react"
import { Button, Spinner } from "reactstrap"

/**
 * todo :
 * buat component berdasarkan color and classname nya
 * loading dibuat format jepang
 */
export default function SButton({
  children,
  onClick,
  color,
  loading,
  disabled,
  className,
  size,
  style,
}) {
  return (
    <Button
      className={`btn btn-${color} waves-effect waves-light ${className}`}
      onClick={onClick}
      color={color}
      disabled={disabled}
      size={size}
      style={style}
    >
      {loading ? <Spinner size="sm" /> : children}
    </Button>
  )
}
